module.exports = __webpack_public_path__ + "static/media/21ECLAC48.b0ab3a54.jpg";